import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { IconToggleGroup, type IconToggleOption } from 'Components/IconToggleGroup';

export interface ReportButtonConfig {
  icon: React.ReactNode;
  tooltip: string;
  route: string;
  activeRoute?: string;
  onClick?(): void;
}

interface ReportsButtonGroupProps {
  buttons: ReportButtonConfig[];
}

export const ReportsButtonGroup = ({ buttons }: ReportsButtonGroupProps) => {
  const location = useLocation();
  const history = useHistory();

  const activeRoute =
    buttons.find((button) => location.pathname.includes(button.activeRoute ?? button.route))?.route ??
    buttons[0]?.route ??
    '';

  const options: IconToggleOption[] = buttons.map((button) => ({
    value: button.route,
    tooltip: button.tooltip,
    icon: button.icon,
  }));

  const handleChange = (value: string) => {
    const button = buttons.find((candidate) => candidate.route === value);
    if (button?.onClick) {
      button.onClick();
      return;
    }
    history.push(value);
  };

  return <IconToggleGroup options={options} value={activeRoute} onChange={handleChange} />;
};
